import { Col, Row } from 'antd'
import { Branches } from 'gadjet-v2-types/dist/model'

import BranchSettlementForm from '../../Forms/BranchSettlementForm'

type Props = { hqId: number; branchId: number; branch?: Branches; onRefresh: () => void }

export default function BranchSettlementTab({ hqId, branchId, branch, onRefresh }: Props): JSX.Element {
  return (
    <Row gutter={20}>
      <Col span={10}>
        <BranchSettlementForm hqId={hqId} branchId={branchId} branch={branch} onRefresh={onRefresh} />
      </Col>
    </Row>
  )
}
